import { useState,useEffect, useRef } from "react";
import { Box, useToast,Spacer,Button,Input, NumberInput,NumberInputField, Divider,Menu,MenuButton,
    MenuItem,Tooltip,MenuList,SkeletonCircle,SkeletonText } from "@chakra-ui/react";
import { getPopisGovedoData } from "../../util/apiMRgg";
import { getPasmine } from "../../util/apiPasmina";
import { MdCancel,MdSaveAlt,MdDeleteOutline } from "react-icons/md";
import { ArrowRightIcon,DeleteIcon } from "@chakra-ui/icons";
import LokacijaSelect2 from "../lokacija/LokacijaSelect2";
import GovedoSearch from "../govedo/GovedoSearch";
import { getGovedoById02 } from "../../util/apiGovedo";
import { userCanEdit } from "../../util/grunt";

export default function PopisiGovedaItemDetails({popisgovedoid,onCancel,onSave,onSaveAndUpdateRgg,isReadOnly=false,onDelete}) {
    const [data,setData]=useState(null);
    const [pasmine,setPasmine]=useState([]);
    const [showazurirajrgg,setShowAzurirajRgg]=useState(true);
    const [isfetchingdata,setIsFetchingData]=useState(true);
    const [selectboks,setSelectBoks]=useState(false);
    const [selectgovedo,setSelectGovedo]=useState(false);
    const [isError,setIsError]=useState(false);
    const toast=useToast();

    

    

    useEffect(() => {
      const getData=async()=>{
        let _errmsg="";
        try {
           
            const res=await getPopisGovedoData(popisgovedoid);
            const resPas=await getPasmine();

            if (res.status===200) {
                if (res.res!==null) {
                    setData(res.res)    
                    setPasmine(resPas.res);
                } else {
                    setIsError(true);
                    _errmsg="Greška kod dohvata podataka!"
                }
                
            } else {
                _errmsg=res.message;
            }
            
        } catch (error) {
            _errmsg=error.message;
        } finally {
            setIsFetchingData(false);
            if (_errmsg!=="") {
                toast({
                    title:"RGG",
                    status:"error",
                    description:_errmsg,
                    isClosable:true,
                    duration:2500,
                    position:"top-right",
                });
            }
        }
      }
      getData();
    }, [])
    const changeSpol=()=>{
        if (data.spol==="m") {
            setData({...data,spol:"f"})
        } else {
            setData({...data,spol:"m"})
        }
    }
    const getSpolForDisplay=(x)=>{
        if (x.toLowerCase()==="m") {
            return "M";
        } else if(x.toLowerCase()==="f") {
            return "Ž";
        } else {
            return "";
        }
    }
    const changePasmina=(passif,pasnaziv)=>{
        setData({...data,pasmina_sifra:passif,pasmina:pasnaziv});
    }
    const buildMenuButtonPasmine=()=>{
        //let i=0;
        //let b=true;
        return (
            <Menu placement={'auto'} preventOverflow={true}>
                 <Tooltip label={'Odabir pasmine'}>
                    <MenuButton as={Button}
                      aria-label='Options' isDisabled={!userCanEdit() || isReadOnly}
                      variant={'outline'}
                      colorScheme={'grunt2'}
                      size={'xs'}>...</MenuButton>
                    
                  </Tooltip>
                    <MenuList overflow={'visible'}>
                        {
                            
                            pasmine.map((item,index)=>{
                                if (index%2===0) {
                                    const p0=pasmine[index];
                                    const p1=index+1===pasmine.length?{sifra:'',naziv:''}:pasmine[index+1];
                                    return(
                                        <Box display={'flex'} flexDir={'row'} flex={1}>
                                            <Box flex={1}>
                                                <MenuItem fontSize={'xs'} onClick={()=>changePasmina(p0.sifra,p0.naziv)}>
                                                    {p0.naziv}
                                                </MenuItem>
                                            </Box>
                                            <Box flex={1}>
                                                <MenuItem isDisabled={p1.sifra===""} fontSize={'xs'} onClick={()=>changePasmina(p1.sifra,p1.naziv)}>
                                                    {p1.naziv}
                                                </MenuItem>
                                            </Box>
                                        </Box>
                                    )    
                                }
                                
                            })
                        }
                      
                    </MenuList>
              </Menu>
        )
    }
    const OdjeljakIsSelected=(id,nazivodj,nazivtov,nazivlok)=>{
        setData({...data,boks_id:Number(id),odjeljak:nazivodj,toviliste:nazivtov,lokacija:nazivlok})
        setSelectBoks(false);
    }
    const getFontColor=(x,y)=>{
        if (x===y) {
            return 'black';
        } else {
            return 'red';
        }
    }
    const onRfIdChange=(valstr,valnum)=>{
        setData({...data,rfid:valstr.substring(0,20)})
    }
    
    const onGovChanged=async (govedo)=>{
        let govid=govedo.govedo_id;
        try {
            setShowAzurirajRgg(false);
            setIsFetchingData(true);
            const res=await getGovedoById02(govid);
            if (res.status===200) {
                const _d=data;
                _d.zivbr=res.res[0].zivbr;
                _d.rfid_baza=res.res[0].rfid;
                _d.spol_baza=res.res[0].spol;
                _d.pasmina_sifra_baza=res.res[0].pasmina_sifra;
                _d.boks_id_baza=res.res[0].odjeljak_id;
                _d.odjeljak_baza=res.res[0].odjeljak;
                _d.toviliste_baza=res.res[0].toviliste;
                _d.lokacija_baza=res.res[0].lokacija;
                _d.pasmina_baza=res.res[0].pasmina_naziv;
                setData(_d);
              
            } else {
                throw new Error(res.message);
            }
        } catch (error) {
            alert(error.message)
        } finally {
            setIsFetchingData(false)
        }

    }
    const AzurirajRggDataDisabled=()=>{
        let _res=true;
        if (data.govedo_id!==0 && (data.rfid!==data.rfid_baza || data.boks_id!==data.boks_id_baza || data.spol!==data.spol_baza)) {
            _res=false;
        }
        if (showazurirajrgg===false) {
            _res=true;
        }
        if (data.govedo_id===0 || data.govedo_migracija_id===0) {
            _res=true;
        }
        if (!userCanEdit()) {
            _res=true;
        }
        if (isReadOnly) {
            _res=true;
        }
        return _res;
    }
    const buildScreenGovedo=()=>{
        if (!selectgovedo) {
            return (
                <>
                    <Box display={'flex'} flexDir={'row'}>
                <Box flex={5} fontWeight={'semibold'}>Životni broj</Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} mb={'0.5rem'}>
                <Box display={'flex'} flex={5} flexDir={'row'}  mr={'0.3rem'}>
                    <Input focusBorderColor='grunt2.400' variant={'outline'} colorScheme="grunt2" size={'xs'} value={data.zivbr}/>
                    <Button isDisabled={!userCanEdit() || isReadOnly} size={'xs'} colorScheme={'grunt2'} variant={'outline'} onClick={()=>setSelectGovedo(!selectgovedo)}>...</Button>
                </Box>
                <Box flex={5}>
                    <Input focusBorderColor='grunt2.400' variant={'filled'} colorScheme="grunt2" size={'xs'} isReadOnly value={data.govedo_id!==0?data.zivbr:""}/>
                </Box>
            </Box>
            <Divider/>
            <Box display={'flex'} flexDir={'row'}>
                <Box flex={5} fontWeight={'semibold'}>RFID</Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} mb={'0.5rem'}>
                <Box flex={5} mr={'0.3rem'}>
                    <NumberInput focusBorderColor='grunt2.400' onChange={onRfIdChange} id="txtrfid" color={getFontColor(data.rfid,data.rfid_baza)}  variant={'outline'} colorScheme="grunt2" size={'xs'} value={data.rfid}>
                        <NumberInputField/>
                    </NumberInput>
                </Box>
                <Box flex={5}><Input focusBorderColor='grunt2.400' variant={'filled'} colorScheme="grunt2" size={'xs'} isReadOnly value={data.rfid_baza}/></Box>
            </Box>
            <Divider/>
            <Box display={'flex'} flexDir={'row'}>
                <Box flex={5} fontWeight={'semibold'}>Spol</Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} mb={'0.5rem'}>
                <Box display={'flex'} flex={5} mr={'0.5rem'} flexDir={'row'}>
                    <Input focusBorderColor='grunt2.400' variant={'filled'} isReadOnly color={getFontColor(data.spol,data.spol_baza)} colorScheme="grunt2" size={'xs'} value={getSpolForDisplay(data.spol)}/>
                    <Button isDisabled={!userCanEdit() || isReadOnly} size={'xs'} colorScheme={'grunt2'} variant={'outline'} onClick={changeSpol}>...</Button>
                </Box>
                <Box flex={5}><Input focusBorderColor='grunt2.400' variant={'filled'} colorScheme="grunt2" size={'xs'} isReadOnly value={getSpolForDisplay(data.spol_baza)}/></Box>
            </Box>
            <Divider/>
            <Box display={'flex'} flexDir={'row'}>
                <Box flex={5} fontWeight={'semibold'}>Pasmina</Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} mb={'0.5rem'}>
                <Box display={'flex'} flexDir={'row'} flex={5} mr={'0.3rem'}>
                    <Input focusBorderColor='grunt2.400' variant={'outline'} color={getFontColor(data.pasmina_sifra,data.pasmina_sifra_baza)} colorScheme="grunt2" size={'xs'} value={data.pasmina}/>
                    {buildMenuButtonPasmine()}
                </Box>
                <Box flex={5}><Input focusBorderColor='grunt2.400' variant={'filled'} colorScheme="grunt2" size={'xs'} isReadOnly value={data.pasmina_baza}/></Box>
            </Box>
            <Divider/>
            <Box display={'flex'} flexDir={'row'}>
                <Box flex={5} fontWeight={'semibold'}>Boks</Box>
            </Box>
            {!selectboks?
            <Box>
            <Box display={'flex'} flexDir={'row'} mb={'0.5rem'}>
                <Box flex={5} mr={'0.3rem'}><Input focusBorderColor='grunt2.400' color={getFontColor(data.boks_id,data.boks_id_baza)}  variant={'outline'} colorScheme="grunt2" size={'xs'} value={data.lokacija}/></Box>
                <Box flex={5}><Input focusBorderColor='grunt2.400' variant={'filled'}  colorScheme="grunt2" size={'xs'} isReadOnly value={data.lokacija_baza}/></Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} mb={'0.5rem'}>
                <Box flex={5} mr={'0.3rem'}><Input focusBorderColor='grunt2.400' color={getFontColor(data.boks_id,data.boks_id_baza)}  variant={'outline'} colorScheme="grunt2" size={'xs'} value={data.toviliste}/></Box>
                <Box flex={5}><Input focusBorderColor='grunt2.400' variant={'filled'}  colorScheme="grunt2" size={'xs'} isReadOnly value={data.toviliste_baza}/></Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} mb={'0.5rem'}>
                <Box display={'flex'} flexDir={'row'} flex={5} mr={'0.3rem'}>
                    <Input focusBorderColor='grunt2.400' color={getFontColor(data.boks_id,data.boks_id_baza)}  variant={'outline'} colorScheme="grunt2" size={'xs'} value={data.odjeljak}/>
                    <Button isDisabled={!userCanEdit() || isReadOnly} size={'xs'} colorScheme={'grunt2'} variant={'outline'} onClick={()=>setSelectBoks(true)}>...</Button>
                </Box>
                <Box flex={5}><Input focusBorderColor='grunt2.400' variant={'filled'}  colorScheme="grunt2" size={'xs'} isReadOnly value={data.odjeljak_baza}/></Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} mt={'1.0rem'}>
                
                <Button isDisabled={AzurirajRggDataDisabled()} rightIcon={<ArrowRightIcon/>} size={'xs'} colorScheme={'grunt2'} variant={'outline'} onClick={SaveDataAndUpdateRgg}>Ažuriraj podatke goveda u registru</Button>
            </Box>
            
            </Box>
            :
            <Box pt={'0.5rem'}>
                <LokacijaSelect2 defaultOdjeljakId={data.boks_id} onCancel={()=>setSelectBoks(false)} onOdjeljakSelect={OdjeljakIsSelected}/>
            </Box>
        }
            <Divider/>
                </>
            )
        } else {
            return (
                <>
                    <GovedoSearch knjiga_id={data.knjiga_id} onClose={()=>setSelectGovedo(false)} onSelect={onGovChanged}/>
                </>
            )
        }
    }

    const buildScreen=()=>{
        if (!isfetchingdata && isError===false) {
            return (
            <>
            <Box display={'flex'} flexDir={'row'} fontSize={'sm'} fontWeight={'bold'} mb={'1rem'}>
                <Box flex={5}>Prijavljeno</Box>
                <Box flex={5}>Evidentirano u RGG</Box>
            </Box>
            
            {buildScreenGovedo()}
            
            </>
            )
        } 
    }
    const showIsFetching=()=>{
        if (isfetchingdata) {
            return (
            <Box>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={15} spacing='3' skeletonHeight='2' />
            </Box>
            )
        }
    }
    const SaveData=()=>{
        onSave(data.id,data.zivbr,data.rfid,data.spol,data.pasmina_sifra,data.boks_id,data.odjeljak,data.toviliste,data.lokacija);
    }
    const SaveDataAndUpdateRgg=()=>{
        onSaveAndUpdateRgg(data.id,data.zivbr,data.rfid,data.spol,data.pasmina_sifra,data.boks_id,data.odjeljak,data.toviliste,data.lokacija);
    }
    
    return (
        <Box display={'flex'} flexDir={'column'} flex={1} m={'0.5rem'} h={'90%'} fontSize={'xs'}>
            {showIsFetching()}
            {buildScreen()}
            <Spacer/>
            <Box justifySelf={'flex-end'} display={'flex'} flexDirection={'row'} h={'2rem'}>
                <Button isDisabled={selectboks || !userCanEdit() || isReadOnly} rightIcon={<MdSaveAlt/>} size={'xs'} colorScheme={'grunt2'} variant={'solid'} onClick={SaveData}>Spremi</Button>
                <Button isDisabled={selectboks} ml={'1.5rem'} rightIcon={<MdCancel/>} size={'xs'} colorScheme={'grunt2'} variant={'outline'} onClick={onCancel}>Odustani</Button>
                
            </Box>
           
        </Box>
    )
}